import {
  getJobInvoiceDetailsDataSource,
  getJobsInvoiceDataSource
} from '@store/invoices/jobsInvoice/jobsInvoice.requests';
import {jobsInvoiceStore} from '@store/invoices/jobsInvoice/jobsInvoice.store';
import {entitiesPropsFactory, selectAllEntitiesApply} from '@ngneat/elf-entities';
import {Observable} from 'rxjs';
import {SelectItem} from '@components/inputs/select/Select.component';
import {select} from '@ngneat/elf';

const {invoicesUIEntitiesRef} = entitiesPropsFactory('invoicesUI');
const {invoicesEntitiesRef} = entitiesPropsFactory('invoices');

export class JobsInvoiceQuery {
  store = jobsInvoiceStore;

  sort$ = this.store.pipe(select((state) => state.sort));
  pagination$ = this.store.pipe(select((state) => state.tablePagination));
  status$ = this.store.pipe(select(state => state.status));
  from$ = this.store.pipe(select(state => state.from));

  jobsInvoice$ = getJobsInvoiceDataSource.data$();

  invoices$ = getJobInvoiceDetailsDataSource.data$();
  selectedInvoices$ = this.store.pipe(selectAllEntitiesApply({
    mapEntity: (e) => e.id,
    filterEntity: (e) => e.selected,
    ref: invoicesUIEntitiesRef,
  }));

  get totalRows() {
    return this.store.getValue().pagination.total;
  }

  invoicesClientKind$ = (search?: string): Observable<SelectItem[]> => this.store.pipe(selectAllEntitiesApply({
    mapEntity: (e) => ({label: e.organisationKind ?? '-', value: e.organisationKind ?? '-'}),
    filterEntity: (e) => !search || e.organisationKind.toLowerCase().includes(search.toLowerCase()),
    ref: invoicesEntitiesRef,
  }));
}

export const jobsInvoiceQuery = new JobsInvoiceQuery();
